import { useUnit } from 'effector-react'
import { matchPath } from 'react-router'

import { LocalStorageKeys } from '@/consts/localStorage.ts'
import { Pages } from '@/consts/routes.ts'
import { $creatorId } from '@/models/creators.ts'
import { $currentPage } from '@/models/router.ts'
import type { Route } from '@/utils/constants.ts'

export const getInitialCreatorId = () => {
  // eslint-disable-next-line effector/no-getState
  const page = $currentPage.getState()
  const idFromPath = getCreatorIdFromPath(page)

  if (idFromPath) {
    return idFromPath
  }

  const savedId = parseInt(
    localStorage.getItem(LocalStorageKeys.PERSISTED_CREATOR_ID) ?? '',
  )

  if (savedId) {
    return savedId
  }

  return null
}

export const getCreatorIdFromPath = (path: string) => {
  const idFromPathParam = (
    matchPath(Pages.CREATOR_BASED_PATH, path) ||
    matchPath(Pages.CHATTING_UI, path)
  )?.params.creatorId

  return idFromPathParam ? parseInt(idFromPathParam) : null
}

export function useCreatorUrl(
  route: Route<(creatorId: number | string) => string>,
): string {
  const creatorId = useUnit($creatorId)

  return route.asUrl(creatorId!)
}
